'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainHeader from './MainHeader';
import MainPageContent from './MainPageContent';
import Sidebar from '../Sidebar/Sidebar';
import AboutMenu from './AboutMenu';
import { useI18nReady } from '@/hooks/useI18nReady';

type MainPageProps = {
  mode?: 'samples' | 'about';
};

const MainPage = ({ mode = 'samples' }: MainPageProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useTranslation();
  const isI18nReady = useI18nReady();

  // Wait for i18n to initialize to prevent hydration mismatch
  if (!isI18nReady) {
    return (
      <div className='h-screen flex flex-col'>
        <MainHeader />
        <div className='flex flex-row flex-1 overflow-hidden' />
      </div>
    );
  }

  // Note: Russian has no titleEnd, so conditionally render it
  const titleEnd = t('mainPage.sidebar.titleEnd');

  return (
      <div className='h-screen flex flex-col'>
        <MainHeader />
        <div className='flex flex-row flex-1 overflow-hidden'>
          <Sidebar className='hidden xl:block p-6 sm:p-8 w-91 flex-shrink-0'>
            {mode === 'samples' ? (
              <>
                <Sidebar.Header
                  title={
                    <>
                      {t('mainPage.sidebar.title')}{' '}
                      <span className='text-accent-blue'>{t('mainPage.sidebar.titleHighlight')}</span>
                      {titleEnd && ` ${titleEnd}`}
                    </>
                  }
                  onSearchChange={setSearchQuery}
                />
                {/* <Sidebar.Content>
                  <Sidebar.FilterGroup title='Difficulty level'>
                    <Sidebar.FilterItem label='Beginner' />
                    <Sidebar.FilterItem label='Intermediate' />
                    <Sidebar.FilterItem label='Advanced' />
                  </Sidebar.FilterGroup>
                  <Separator className='my-4' />

                  <Sidebar.FilterGroup title='Genre'>
                    <Sidebar.FilterItem label='Classical' />
                    <Sidebar.FilterItem label='Jazz' />
                    <Sidebar.FilterItem label='Pop' />
                    <Sidebar.FilterItem label='Folk' />
                  </Sidebar.FilterGroup>
                  <Separator className='my-4' />

                </Sidebar.Content> */}
              </>
            ) : (
              <AboutMenu />
            )}
          </Sidebar>

          <div className='flex-1 overflow-y-auto'>
            <MainPageContent mode={mode} searchQuery={searchQuery} onSearchChange={setSearchQuery} />
          </div>
        </div>
      </div>
  );
};

export default MainPage;
